export default function controlDirective() {
  return {
    template: require('./control.html'),
    restrict: 'E',
    controller: 'ControlController',
    controllerAs: 'controlVM',
    bindToController: true,
    replace: true,
    scope: {
      controlDetail: '=',
      isAssign: '=',
      tooltipAppendToSelector: '@',
      unAssign: '<',
      risk: '<',
      assignAsset: '<',
      isEditProcessDialog: '<',
      isApproveProcessDialog: '<',
      isPraProcessMain: '<',
      process: '<',
      isEditAssetDialog: '<',
      showActionIcons: '<',
      showBulkDelete: '<',
      showSyncControl: '<',
      showSyncControlMain: '<',
      showSyncAsset: '<',
      showSyncRiskMain: '<',
      assetType: '<',
    },
  };
}
